import flow from 'lodash/flow';
import {
  getServerValidationErrors,
  mapPropsToValidators,
  validate,
} from '../validators';
import { matrixRatingRequired, ratingRequired } from './validators';
import {
  commonQuestionState,
  updateWhy,
  updateMatrixWhy,
} from '../response/reducer';
import prefill, { prefillWhy } from '../prefillAnswers';

const reducer = props =>
  props.matrix ? matrixReducer(props) : simpleReducer(props);
export default reducer;

const update = action => state => ({
  ...state,
  value: action.value,
});

const addSimpleState = props => state => ({
  ...state,
  value: (prefill(props.tmap) || '').toString().replace('rating', ''),
  validators: mapPropsToValidators(
    {
      required: props.required,
    },
    {
      required: ratingRequired,
    }
  ),
});

const simpleReducer = props => (state, action) => {
  if (state === undefined) {
    return flow(
      commonQuestionState(props),
      getServerValidationErrors(props),
      addSimpleState(props)
    )({});
  }

  switch (action.type) {
    case 'RATING_CHANGE':
      return flow(update(action), validate(action))(state);

    case 'WHY_CHANGE':
      return flow(updateWhy(action), validate(action))(state);

    case 'SUBMIT':
      return flow(validate(action))(state);

    default:
      return state;
  }
};

//

const matrixUpdate = action => state => ({
  ...state,
  rows: state.rows.map(
    (row, rowIndex) =>
      rowIndex === action.rowIndex
        ? {
            ...row,
            value: action.value,
          }
        : row
  ),
});

const addMatrixState = props => state => ({
  ...state,
  rows: props.rows.map(row => ({
    name: row.name,
    value: (prefill(props.tmap, row.name, 0) || '')
      .toString()
      .replace('rating', ''),
    why: {
      isTouched: false,
      value: prefillWhy(row.name, props.tmap),
    },
  })),
  validators: mapPropsToValidators(
    {
      required: props.required,
    },
    {
      required: matrixRatingRequired,
    }
  ),
});

const matrixReducer = props => (state, action) => {
  if (state === undefined) {
    return flow(
      commonQuestionState(props),
      getServerValidationErrors(props),
      addMatrixState(props)
    )({});
  }

  switch (action.type) {
    case 'RATING_CHANGE':
      return flow(matrixUpdate(action), validate(action))(state);

    case 'MATRIX_WHY_CHANGE':
      return flow(updateMatrixWhy(action), validate(action))(state);

    case 'SUBMIT':
      return flow(validate(action))(state);

    default:
      return state;
  }
};
